// CourseCartCheckoutPanel.jsx

import React, { useState, useContext } from "react";
import PaperPlaneIcon from "../../../components/icons/paper-plane-icon";
import "./CourseCartCheckoutPanel.css";
import { useCart } from "../../../store/CartContext";
import { Context } from '../../../index'
import ButtonBase from "../../TeacherCabinet/components/buttons/ButtonBase";
import { updateUser } from "../../../http/UserAPI";

const CourseCartCheckoutPanel = ({ onPromoCodeClick, onPayClick }) => {
    const [promoCode, setPromoCode] = useState('');
    const [isAgree, setIsAgree] = useState(false);
    const { totalPrice, } = useCart();
    const [emailPopupVisible, setEmailPopupVisible] = useState(false);
    const [paymentPopupVisible, setPaymentPopupVisible] = useState(false);
    const [paymentLink, setPaymentLink] = useState(null)
    const [email, setEmail] = useState('');
    const { user } = useContext(Context)


    const handlePromoCodeClick = () => {
        onPromoCodeClick(promoCode);
    }

    const changeUserEmail = async () => {
        try {
            await updateUser({ email: email })
            user.setUser({ ...user.user, email: email })
            setEmailPopupVisible(false)
        } catch (e) {
            console.error(e)
        }
    }

    const handlePayClick = async () => {
        if (!user.needsProfileUpdate) {
            const response = await onPayClick({ email: user.user.email.length ? user.user.email : email });
            setPaymentLink(response.payment_url)
            setPaymentPopupVisible(true)
            return
        }
        setEmailPopupVisible(user.needsProfileUpdate)
    }

    return (
        <div className="checkout-panel">
            <h2 className="checkout-panel__title">
                Робот <span className="checkout-panel__highlight">Boost</span> рад, что ты выбрал нас!
            </h2>

            <div className="checkout-panel__promo">
                <input
                    type="text"
                    className="checkout-panel__promo-input"
                    placeholder="Промокод"
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value)}
                />
                <button
                    className={"checkout-panel__promo-btn" + (!promoCode
                        ? " checkout-panel__promo-btn--disabled"
                        : "")
                    }
                    onClick={handlePromoCodeClick}
                >
                    <PaperPlaneIcon size={16} color={"rgba(54, 54, 69, 0.5)"} className={"checkout-panel__promo-icon"} />
                </button>
            </div>

            <p className="checkout-panel__total-label">Итого</p>
            <p className="checkout-panel__total-price">
                {typeof totalPrice === 'number' ? totalPrice.toFixed(2) : '0.00'} ₽
            </p>


            <button
                className={"checkout-panel__pay-btn" + (!isAgree ? " checkout-panel__pay-btn--disabled" : "")}
                onClick={handlePayClick}>
                Оплатить
            </button>

            <label className="checkout-panel__agreement">
                <input
                    type="checkbox"
                    checked={isAgree}
                    onChange={(e) => setIsAgree(e.target.checked)}
                />
                <a href="/files/public_offer.pdf" target='_blank' download rel="noreferrer">  Принимаю условия оферты</a>
            </label>

            {emailPopupVisible && <div className="fixed top-0 bottom-0 left-0 right-0 z-50 flex items-center justify-center">
                <div className="fixed top-0 bottom-0 left-0 right-0 bg-black/30"></div>
                <div className=" bg-white p-5 rounded-2xl relative z-2">
                    <form className="flex flex-col gap-4" >
                        <h4 className="font-semibold block px-4">Для продолжения оплаты введите ваш email</h4>
                        <input type="email" placeholder="Введите email" className="border border-solid border-lavender-30 rounded-2xl" onChange={e => setEmail(e.target.value)} />
                        <ButtonBase onClick={changeUserEmail} type="button">Сохранить</ButtonBase>
                    </form>
                </div>
            </div>}
            {paymentPopupVisible && <div className="fixed top-0 bottom-0 left-0 right-0 z-50 flex items-center justify-center">
                <div className="fixed top-0 bottom-0 left-0 right-0 bg-black/30"></div>
                <div className=" bg-white p-5 rounded-2xl relative z-2">
                    <div className="flex flex-col gap-2 items-center font-medium">
                        <h4 className="font-semibold block px-4 text-lg">Оплата</h4>
                        <p>Вы будете автоматически направлены на страницу оплаты.</p>
                        <p>Если страница оплаты не открылась, перейдите по ссылке:</p>
                        <a className="text-lavender underline" href={paymentLink}>{paymentLink}</a>
                    </div>
                </div>
            </div>}
        </div>
    )
}
export default CourseCartCheckoutPanel;